import axios from 'axios'

const api = axios.create({
  baseURL: '/api',
  timeout: 10000,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
})

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token')
    if (token) config.headers.Authorization = `Bearer ${token}`
    return config
  },
  (error) => Promise.reject(error)
)

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      switch (error.response.status) {
        case 401: {
          // Zaal-schermen / OBS-browser-sources hebben géén JWT en horen bij
          // een 401 gewoon leeg te blijven, NIET naar /login te bouncen. Anders
          // krijg je een oneindige bounce-loop op de beamer.
          const pad = typeof window !== 'undefined' ? window.location.pathname : ''
          const publiek = /^\/(scherm|overlay|zaal|scherm-invul|scherm-admin)(\/|$)/.test(pad)
                       || /^\/(kempenvision|imagecompo)\/stage(\/|$)/.test(pad)
                       || /^\/tournaments\/[^/]+\/stage(\/|$)/.test(pad)
          if (!publiek) {
            localStorage.removeItem('auth_token')
            window.location.href = '/login'
          }
          break
        }
        case 403:
          console.error('Access forbidden')
          break
        case 404:
          console.error('Resource not found')
          break
        case 500:
          console.error('Server error')
          break
        default:
          console.error('API Error:', error.response.data)
      }
    } else if (error.request) {
      console.error('Network error - no response received')
    } else {
      console.error('Error:', error.message)
    }
    return Promise.reject(error)
  }
)

export default api
